import {
    ADDITIONAL_PAGE_OPTIONS,
    SalesChannel,
    SALESCHANNEL_CONSUMER,
} from '@vfde-fe/sails-constants';
import { getIsTradeInEligibleFromDom } from './domHelper';

/**
 * Check if trade in can be selected for this device/saleschannel
 * @param salesChannel
 */
export function getIsTradeInEligible (salesChannel: SalesChannel = SALESCHANNEL_CONSUMER): boolean {
    return [SALESCHANNEL_CONSUMER].indexOf(salesChannel) !== -1 && getIsTradeInEligibleFromDom() || getIsTradeInEligibleFromPageOptions();
}

/**
 * Check if trade in can be selected based on additional page options
 */
export function getIsTradeInEligibleFromPageOptions (): boolean {
    return window[ADDITIONAL_PAGE_OPTIONS]?.promos?.tradeIn !== undefined;
}
